
import React from 'react';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { FormStepProps } from '../types';

const DeviceProvisioningStep: React.FC<FormStepProps> = ({ formData, handleChange }) => {
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="space-y-2">
          <Label htmlFor="provisioningKey">Provisioning Key</Label>
          <Input
            id="provisioningKey"
            name="provisioningKey"
            value={formData.provisioningKey}
            onChange={handleChange}
            placeholder="Enter provisioning key"
          />
        </div>
        
        <div className="space-y-2">
          <Label htmlFor="activationCode">Activation Code</Label>
          <Input
            id="activationCode"
            name="activationCode"
            value={formData.activationCode}
            onChange={handleChange}
            placeholder="Enter activation code"
          />
        </div>
      </div>
    </div>
  );
};

export default DeviceProvisioningStep;
